import { render, staticRenderFns } from "./import-list-page.vue?vue&type=template&id=5b40ab55&"
import script from "./import-list-page.vue?vue&type=script&lang=js&"
export * from "./import-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports